import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Paper,
  Button,
  Grid,
} from "@material-ui/core";
import { useState } from "react";
import ProductViewCountIcon from "../../icons/ProductViewCountIcon";
import countdownIcon from "../../../images/countdown-icon.svg";
import websiteCouponIcon from "../../../images/website-coupon-icon.svg";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import discountIcon from "../../../images/discount-tag.svg";
import priceIcon from "../../../images/price-tag.svg";
import useStyles from "./styles";
import dayjs from "dayjs";

function Product({ product }) {
  const classes = useStyles();
  const [promoCodeExpired, setPromoCodeExpired] = useState(
    product.dueDate && dayjs().isAfter(dayjs(product.dueDate))
  );

  const getDiscountPercentage = (productOriginalPrice, productNewPrice) => {
    return `-${Math.round(
      ((productOriginalPrice - productNewPrice) / productOriginalPrice) * 100
    )}%`;
  };

  const getProductCategory = (productCategory) => {
    switch (productCategory) {
      case "HOT_DEALS":
        return "Hot deals";
      case "PROMO_CODES":
        return "Promo codes";
      default:
        return "klnklnk";
    }
  };

  return (
    <Grid item lg={3} md={4} sm={6} xs={12}>
      <Card className={classes.card}>
        {promoCodeExpired && (
          <Paper className={classes.promoCodeExpiredOverlay}>
            <Typography className={classes.promoCodeExpiredText}>
              Promo Code Expired!
            </Typography>
          </Paper>
        )}
        <div className={`${classes.productCategoryContainer}`}>
          <div className={classes.productCategory}>
            <Typography variant="body1" className={classes.productCategoryText}>
              {getProductCategory(product.category)}
            </Typography>
          </div>
        </div>
        <CardMedia className={`${classes.cardMedia}`} title={product.name}>
          <img
            src={product.imageUrl}
            alt="Amazon product"
            className={classes.image}
          />
        </CardMedia>
        <CardContent className={classes.productInfo}>
          <div>
            <Typography className={classes.productName} variant="body2">
              {product.name}
            </Typography>
          </div>
          <Paper className={classes.productPrice} elevation={3}>
            <div className={classes.productInfoContainer}>
              <img src={priceIcon} alt="Price Icon" height={25} width={25} />
              &nbsp;
              <Typography
                variant="subtitle2"
                className={`${
                  product.newPrice
                    ? classes.productOldPrice
                    : classes.productNewPrice
                }`}
              >
                {`${Number(product.originalPrice).toFixed(2)}`}
              </Typography>
              &nbsp;
              {product.newPrice && (
                <Typography variant="h5" className={classes.productNewPrice}>
                  {`${Number(product.newPrice).toFixed(2)}`}
                </Typography>
              )}
            </div>
            <div className={classes.productInfoContainer}>
              <img
                src={discountIcon}
                alt="Discount Icon"
                height={25}
                width={25}
              />
              &nbsp;
              {(product.newPrice || product.discountPercentage) && (
                <Typography
                  variant="subtitle1"
                  className={classes.productDiscountPercentage}
                >
                  {product.discountPercentage
                    ? `-${product.discountPercentage}%`
                    : getDiscountPercentage(
                        product.originalPrice,
                        product.newPrice
                      )}
                </Typography>
              )}
            </div>
            {product.websiteCoupon && (
              <div className={classes.productInfoContainer}>
                <img
                  src={websiteCouponIcon}
                  alt="Website Coupon Icon"
                  height={25}
                  width={25}
                />
                &nbsp;
                <Typography
                  variant="subtitle2"
                  className={classes.productDiscountPercentage}
                >
                 + CLIP {product.websiteCoupon} COUPON!
                </Typography>
              </div>
            )}
            <div className={classes.productInfoContainer}>
              <ProductViewCountIcon />
              &nbsp;
              <Typography
                variant="subtitle1"
                className={classes.productExtraInfo}
              >
                {product.viewCount}
              </Typography>
            </div>
            {product.dueDate && (
              <div className={classes.productInfoContainer}>
                <img
                  src={countdownIcon}
                  alt="Countdown Icon"
                  height={25}
                  width={25}
                />
                &nbsp;
                <Typography
                  variant="subtitle1"
                  className={classes.productExtraInfo}
                >
                  <Countdown
                    date={product.dueDate}
                    onComplete={() => setPromoCodeExpired(true)}
                  />
                </Typography>
              </div>
            )}
          </Paper>
          <Link to={`/products/${product._id}`} className={classes.link}>
            <Button variant="contained" className={classes.productButton}>
              <b>
                {product.category === "PROMO_CODES"
                  ? "Get promo code"
                  : "Go to product"}
              </b>
            </Button>
          </Link>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default Product;
